/**
* @module @pakal/arity
* @copyright © 2018 Yisrael Eliav <yisraelx@gmail.com> (https://github.com/yisraelx)
* @license MIT
*/
var FUNCTIONS = {};
function arity(fn, length) {
    if (length === void 0) { length = fn.length; }
    if (!FUNCTIONS[length]) {
        var params = [];
        for (var index = 0; index < length; index++) {
            params.push("p" + index);
        }
        FUNCTIONS[length] = new Function("fn", "return function (" + params.join(', ') + "){\n            return fn.apply(this, arguments);\n        };");
    }
    return FUNCTIONS[length](fn);
}

export default arity;
//# sourceMappingURL=index.esm.js.map
